import { render, staticRenderFns } from "./OrganizationFormTable.vue?vue&type=template&id=4413625a&"
import script from "./OrganizationFormTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports